/**
 * 首页数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref, onMounted, onUnmounted } from 'vue';
import { getAccounts, getNovels } from './api';

export const useWebSocket = () => {
    const connected = ref(true); // Axios 总是"连接"状态
    const account = ref([]);
    const novels = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const errorItNovel = ref(null);

    // 请求账号和小说数据
    const fetchNovelsAccount = async () => {
        loading.value = true;
        error.value = null;
        errorItNovel.value = null;

        try {
            // 并行请求账号和小说数据
            const [accountsResult, novelsResult] = await Promise.all([
                getAccounts(),
                getNovels()
            ]);
            // Result 结构：{ code: 0, msg: "success", data: [...] }
            // code=0 成功，code=1 失败
            if (accountsResult.code === 0) {
                account.value = accountsResult.data;
                console.log('获取账号信息成功');
            } else {
                error.value = accountsResult.msg || '获取账号失败';
            }

            if (novelsResult.code === 0) {
                novels.value = novelsResult.data;
                console.log('获取小说信息成功');
            } else {
                errorItNovel.value = novelsResult.msg || '获取小说信息失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            error.value = err.message || '请求数据失败';
            errorItNovel.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    // 组件挂载时自动请求数据
    onMounted(() => {
        fetchNovelsAccount();
    });

    return {
        connected,
        account,
        novels,
        loading,
        error,
        errorItNovel,
        fetchNovelsAccount,
    };
};
